module.exports = __webpack_public_path__ + "images/logo-amazon-2.svg";